import { IExitForm } from '@/Models'
import { useFormContext } from 'react-hook-form'
import * as yup from 'yup'

export const strReq = 'Field must be a string'
export const bolReq = 'Field must be a boolean'
export const reqField = 'Field is required'

export const stepOneSchema = yup.object().shape({
  reasonsForLeaving: yup.array().of(yup.string()).min(1, reqField),
  supervisorName: yup
    .string()
    .required(reqField)
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  employmentStartDate: yup.string().required(reqField),
  employmentEndDate: yup.string().required(reqField),
  currentPosition: yup
    .string()
    .required(reqField)
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  returnOf: yup.array().of(yup.string()).optional(),
  specificEventPromptedResignation: yup
    .string()
    .optional()
    .transform((val) => (val === '' ? undefined : val))
    .typeError(strReq),
  discussedWithSupervisor: yup
    .boolean()
    .required(reqField)
    .transform((val) => (val === '' ? undefined : val))
    .typeError(bolReq),
})

const reasons = [
  'Salary',
  'Family Responsibilities',
  'Job Advancement',
  'Dissatisfied/Management',
  'Personal',
  'Benefits',
  'Return to School',
  'Job Eliminated',
  'Relocation',
  'Health',
  'Retirement',
  'Other',
]

export const StepOneComp = (props: { data: any[] }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<IExitForm>()

  const returnOptions = ['ID card', 'Work tool', 'Credit card', 'Documents', 'Other']

  return (
    <div className='form-step deselect'>
      {/* row 1 */}
      <div className='form-group row justify-content-center'>
        <div className='mb-3 text-start col-md-6 col-lg-5'>
          <label>Supervisor Name:</label>
          <select
            className='form-control input-name'
            {...register('supervisorName')}
            defaultValue=''
          >
            <option value='' disabled>
              Select option
            </option>
            {props.data.map((ctr, index) => (
              <option key={index} value={`${ctr.firstName} ${ctr.lastName}`}>
                {ctr.firstName} {ctr.lastName}
              </option>
            ))}
          </select>
          {errors.supervisorName && (
            <p className='text-danger error-msg'>{errors.supervisorName.message}</p>
          )}
        </div>

        <div className='text-start col-md-6 col-lg-5'>
          <label>Current Position:</label>
          <input type='text' className='form-control input-name' {...register('currentPosition')} />
          {errors.currentPosition && (
            <p className='text-danger'>{errors.currentPosition.message}</p>
          )}
        </div>
      </div>

      {/* Row 2*/}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6 col-lg-5'>
          <label>Employment Start Date:</label>
          <input type='date' className='form-control' {...register('employmentStartDate')} />
          {errors.employmentStartDate && (
            <p className='text-danger'>{errors.employmentStartDate.message}</p>
          )}
        </div>

        <div className='text-start col-md-6 col-lg-5'>
          <label>Employment End Date:</label>
          <input type='date' className='form-control' {...register('employmentEndDate')} />
          {errors.employmentEndDate && (
            <p className='text-danger'>{errors.employmentEndDate.message}</p>
          )}
        </div>
      </div>

      {/* row 3 */}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6 col-lg-5'>
          <label>Returned Items:</label>
          <select multiple className='form-select' {...register('returnOf')}>
            {returnOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          {errors.returnOf && <p className='text-danger'>{errors.returnOf.message}</p>}
        </div>
        <div className='text-start col-md-6 col-lg-5'>
          <label>Reasons for Leaving:</label>
          <select multiple className='form-select' {...register('reasonsForLeaving')}>
            {reasons.map((reason) => (
              <option key={reason} value={reason}>
                {reason}
              </option>
            ))}
          </select>
          {errors.reasonsForLeaving && (
            <p className='text-danger'>{errors.reasonsForLeaving.message}</p>
          )}
        </div>
      </div>

      {/* row 4  */}
      <div className='form-group row justify-content-center row-up'>
        <div className='mb-3 text-start col-md-6 col-lg-5'>
          <label>Specific Event that Prompted Resignation:</label>
          <textarea
            className='form-control small-textarea'
            {...register('specificEventPromptedResignation')}
          />
          {errors.specificEventPromptedResignation && (
            <p className='text-danger'>{errors.specificEventPromptedResignation.message}</p>
          )}
        </div>

        <div className='text-start col-md-6 col-lg-5'>
          <label>Discussed with Supervisor:</label>
          <select
            className='form-select'
            {...register('discussedWithSupervisor', {
              setValueAs: (v) => {
                if (v === true || v === false) return v
                if (v === 'true') return true
                if (v === 'false') return false
                return undefined
              },
            })}
          >
            <option value=''>Select an option</option>
            <option value='true'>Yes</option>
            <option value='false'>No</option>
          </select>
          {errors.discussedWithSupervisor && (
            <p className='text-danger'>{errors.discussedWithSupervisor.message}</p>
          )}
        </div>
      </div>
    </div>
  )
}
